import { TopoImageKey, TopoImageEntry, TopoImageMap } from "../Topology/TopoImageMap";

export class TopoImageLibrary {
	public static FindImage(key: TopoImageKey): HTMLImageElement {
		return TopoImageLibrary.Instance._FindImage(key);
	}

	private static _instance: TopoImageLibrary;
	public static get Instance(): TopoImageLibrary {
		if (TopoImageLibrary._instance == null) {
			TopoImageLibrary._instance = new TopoImageLibrary();
		}
		return TopoImageLibrary._instance;
	}

	public SystemImages: TopoImageMap;

	constructor() {
		this.SystemImages = new TopoImageMap();
	}

	private _FindImage(key: TopoImageKey): HTMLImageElement {
		if (key != null) {

			var entry = this.SystemImages.FindEntry(key);
			if (entry != null)
				return entry.Image;
		}

		return null;
	}

	public SearchSystemTopoImageEntries(key: TopoImageKey): TopoImageEntry {
		return this.SystemImages.FindEntry(key);
	}

	/// <summary>
	/// Used for efficient bulk loading without integrity checking
	/// </summary>
	/// <param name="entry"></param>
	public LoadSystemEntry(entry: TopoImageEntry): void {
		this.SystemImages.AddEntry(entry);
	}

	public Unload(): void {
		this.SystemImages.Clear();
	}
}
